import React, {Component} from 'react';
import { Link } from 'react-router';
import Helmet from "react-helmet";

import GuideButton from '../../components/GuideButton';
import GuideHeader from '../../components/GuideHeader';

export default class ThreeIntro extends Component {
  render() {
    const imageUrl = "https://blacksquare.nyc3.digitaloceanspaces.com/janes_colony/guide/guide_header_flowering_3.jpg";
    return (
      <div>
        <Helmet
          title="Jane's Colony"
          meta={ [
            { name: "description", content: "" },
            { property: "og:title", content: ''},
            { property: "og:url", content: ''},
            { property: "og:image", content: ''},
          ] }
        />
        <GuideHeader imageUrl={imageUrl} />
        <h2>
        Part III: Taking It Further
        </h2>
        <p>
        Part III: Taking It Further, covers additional topics for you to try and experiment with. These are not all advanced or essential, but prove that with a little extra time and effort you can improve your grow operation and maximize the yield of your harvest. 
        </p>
        <GuideButton slugTo="cloning" />
      </div>
    )
  }
}





// WEBPACK FOOTER //
// ./src/content/guide/three_intro.js